import { useEffect } from 'react'
import PromotedBranchStore from '../../../components/promote_changes/context/context'
import TracerPreview from '../../../components/promote_changes/tracer_preview'

const TracerPreviewPage = () => {
  return (
    <PromotedBranchStore>
      <TracerPreview />
    </PromotedBranchStore>
  )
}

export default TracerPreviewPage
